import { requestGet, requestPost, requestPut, requestPostFile } from "../config/Api";

const base = "legal-file/stage";

export const getLegalFileStages = (legalFileType) =>
  requestGet(base, legalFileType ? { legal_file_type: legalFileType } : {});

export const createLegalFileStage = (data) => requestPost(base, data);

export const updateLegalFileStage = (id, data) =>
  requestPut(`${base}/${id}`, data);

export const recalculateLegalFileStages = () =>
  requestPost(`${base}/recalculate`);

// Fuerza una etapa a los expedientes cuyos códigos están en la primera
// columna del Excel/CSV. Quedan marcados como "forzados" y no se recalculan.
export const forceImportLegalFileStages = (file, legalFileStageId) => {
  const data = new FormData();
  data.append("file", file);
  data.append("legal_file_stage_id", legalFileStageId);
  return requestPostFile(`${base}/force-import`, data);
};
